module.exports = __webpack_public_path__ + "static/wroom-c8fe4a59934f408fffaabf157bdd9938.png";